import type { Settings } from '../core/types';

export class AudioManager {
  private context: AudioContext | null = null;
  constructor(private readonly settings: Settings) {}

  async unlock(): Promise<void> {
    this.context ??= new AudioContext();
    if (this.context.state === 'suspended') await this.context.resume();
  }

  play(type: 'tap' | 'hit' | 'critical' | 'heal' | 'ultimate' | 'victory'): void {
    if (!this.context || this.settings.muted) return;
    const now = this.context.currentTime; const oscillator = this.context.createOscillator(); const gain = this.context.createGain();
    const frequency = { tap: 420, hit: 120, critical: 780, heal: 520, ultimate: 90, victory: 660 }[type];
    oscillator.type = type === 'hit' || type === 'ultimate' ? 'sawtooth' : 'sine'; oscillator.frequency.setValueAtTime(frequency, now);
    if (type === 'ultimate') oscillator.frequency.exponentialRampToValueAtTime(520, now + 0.32);
    else oscillator.frequency.exponentialRampToValueAtTime(Math.max(60, frequency * 0.62), now + 0.1);
    const volume = this.settings.masterVolume * this.settings.sfxVolume * 0.13; gain.gain.setValueAtTime(volume, now); gain.gain.exponentialRampToValueAtTime(0.0001, now + (type === 'ultimate' ? 0.5 : 0.14));
    oscillator.connect(gain).connect(this.context.destination); oscillator.start(now); oscillator.stop(now + (type === 'ultimate' ? 0.52 : 0.16));
  }

  dispose(): void { void this.context?.close(); this.context = null; }
}
